import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { AppleProfileEffects } from './apple-profile.effects';
import { appleProfileReducer } from './apple-profile.reducer';

export const provideAppleProfileStore = () => [
  provideState('apple-profile', appleProfileReducer),
  provideEffects([AppleProfileEffects]),
];
